import React from "react";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { useIntl } from "react-intl";
import { Select, Typography } from "antd";
import { useDispatch } from "react-redux";
import { setScope } from "../../features/user/UserSlice";

const { Option } = Select;
const { Text } = Typography;
const BranchSelector = () => {
  let { branchId } = useParams();
  let history = useHistory();
  const intl = useIntl();
  const dispatch = useDispatch();
  const profile = useSelector((state) => state.user.profile);
  const onChange = (value) => {
    const url = "/branches/" + value.toString();
    history.push(url);
    const scope = `branches/${value.toString()}/`;
    dispatch(setScope(scope));
  };
  return profile.branches && profile.branches.length > 1 ? (
    <Select
      style={{ width: "200px" }}
      defaultValue={branchId ? parseInt(branchId) : undefined}
      showSearch
      placeholder={intl.formatMessage({
        id: "app.users.chooseBranch",
      })}
      optionFilterProp="children"
      onChange={onChange}
      filterOption={(input, option) =>
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      {profile.branches.map((b) => (
        <Option value={b.id} key={b.id}>
          {b.name}
        </Option>
      ))}
    </Select>
  ) : profile.branches && profile.branches.length === 1 ? (
    <div className="branchContainer">
      <Text>{profile.branches[0].name}</Text>
    </div>
  ) : null;
};

export default BranchSelector;
